import PropTypes from 'prop-types'
import React from 'react'

import { StarRating, MetaCategories } from '../../pages/search/result/utils'
import TrendingItem from './common/trendingItem'
import MagnifierConfigurator from '../magnifier/configurator'
import Overlay from '../overlay'

const ItemCardListDefault = ({
  item,
  onAddToFavourites,
  rank,
  onAddToCollections,
  onItemLinkClick = () => {},
  onAddToCart = () => {}
}) => {
  return (
    <div>
      {item.trending &&
        <TrendingItem />
      }
      <div className='product-list__columns-container'>
        <div className='product-list__column-detail'>
          <div className='product-list__item-thumbnail'>
            <div className='item-thumbnail'>
              <Overlay position='side' content={MagnifierConfigurator({item})}>
                <div className='item-thumbnail__image'>
                  <a href={`${item.url}?s_rank=${rank}`} onClick={onItemLinkClick}>
                    <img alt={item.name}
                      className='preload no_preview landscape-image-magnifier'
                      height='80' src={item.ui.smallPreviewUrl} title={item.name} width='80' />
                  </a>
                  {item.previews.live_site ? <div className='item-thumbnail__preview'>
                    <a href={item.previews.live_site.url} target='_blank'>Live preview</a>
                  </div> : null}
                </div>
              </Overlay>
            </div>
          </div>

          <div className='product-list__adjacent-thumbnail'>
            <h3 className='product-list__heading'>
              <a className='fds-c-text-link -color-inherit -decoration-reversed'
                href={`${item.url}?s_rank=${rank}`} onClick={onItemLinkClick}>{item.name}</a>
            </h3>

            <div className='product-list__price'>
              <p className='fds-c-text-body -size-m -color-inherit -weight-bold fds-u-m0'>${item.price}</p></div>

            <div className='product-list__info'>
              <div className='product-list__info-author'>
                <a className='fds-c-text-link -color-default -decoration-reversed'
                  href={item.author_url}>{item.author_username}</a>
              </div>

              <div className='product-list__info-rating'>
                {item.rating.rating ? <StarRating rating={item.rating.rating} className='star-rating--search' /> : null}
                {item.rating.rating && item.rating.count ? `${item.rating.count} ratings` : null}
              </div>

              {item.number_of_sales ? <div className='product-list__info-sale'>
                <span className='product-list__info-sale-glyph'>
                  <i className='e-icon -icon-bar-chart' />
                </span>
                {item.number_of_sales} Sales
              </div> : null}
            </div>
          </div>

          <div className='fds-u-clear'>
            <div className='product-list__item-thumbnail-actions'>
              <div className='item-thumbnail-actions -width-full'>
                <ul className='item-thumbnail-actions__list'>
                  <li className='item-thumbnail-actions__control -icon-favorite -responsive-size-l'>
                    <span className='js-favorite-widget is-initialized'>
                      <a href={`/favorites?item_id=${item.id}`}
                        onClick={onAddToFavourites}
                        className={item.ui.isInFavourites ? 'is-active' : ''}
                        rel='nofollow' title='Add to Favorites'><span>Add to Favorites</span></a>
                    </span>
                  </li>

                  <li className='item-thumbnail-actions__control -icon-collection -responsive-size-l'>
                    <span className='is-initialized'>
                      <a
                        href={`/bookmarks/widget?item_id=${item.id}`}
                        className={item.ui.isInBookmarks ? 'is-active' : ''}
                        rel='nofollow'
                        onClick={(event) => onAddToCollections(event)}
                        title='Add to Collection'>
                        <span>Add to Collection</span>
                      </a>
                    </span>
                  </li>

                  <li className='item-thumbnail-actions__control -icon-cart -responsive-size-l'>
                    <span>
                      <a
                        className={item.ui.isInCart ? 'is-active' : ''}
                        onClick={onAddToCart}
                        href={`/cart/configure_before_adding/${item.id}`} rel='nofollow' title='Add to Cart'>
                        <span>Add to Cart</span></a>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className='product-list__column-category'>
          <p className='fds-c-text-body -size-xs fds-u-m0'>
            <MetaCategories classification={item.classification} className='meta-categories -no-slash' />
            <br /> {item.summary}
          </p>
        </div>

        <div className='product-list__column-price'>
          <p className='product-list__price-desktop'>${item.price}</p>
          <div className='product-list__info-desktop'>
            {item.rating.rating ? <StarRating rating={item.rating.rating} className='star-rating--search' /> : null}
            {item.rating.rating ? <br /> : null}
            {item.rating.rating && item.rating.count ? `${item.rating.count} ratings` : null}
            {item.number_of_sales ? <div className='product-list__sales-desktop'>
              <i className='e-icon -icon-bar-chart -size-medium' />
              <br />
              {item.number_of_sales ? `${item.number_of_sales} Sales` : null}
            </div> : null}
          </div>
        </div>
      </div>
    </div>
  )
}

ItemCardListDefault.propTypes = {
  item: PropTypes.object.isRequired,
  onAddToFavourites: PropTypes.func.isRequired,
  rank: PropTypes.number.isRequired,
  onItemLinkClick: PropTypes.func,
  onAddToCart: PropTypes.func
}

export default ItemCardListDefault



// WEBPACK FOOTER //
// ./client/components/itemCard/listDefault.js